// Single source of truth for IDs captured during login.
// Expected localStorage keys (set at login): "tenantId", "userId", "roleId", "role", "username"
export function getSessionLocal() {
  const tenantId = Number(localStorage.getItem("tenantId")) || null;
  const userId   = Number(localStorage.getItem("userId"))   || null;
  const roleId   = Number(localStorage.getItem("roleId"))   || null;
//   const role     = (localStorage.getItem("role") || "").toLowerCase() || null;
  const roleRaw  = localStorage.getItem("role")
                || localStorage.getItem("roleName")
                || localStorage.getItem("userRole")
                || "";
  const role     = roleRaw ? String(roleRaw).toLowerCase() : null;
  const username = localStorage.getItem("username") || null;
  return { tenantId, userId, roleId, role, username };
}

// Normalize: which string roles are considered "can edit"?
export function isEditRoleName(name) {
  if (!name) return false;
  const r = String(name).toLowerCase();
  // Add/adjust names to match your DB
  return ["owner", "admin", "manager", "editor"].includes(r);
}

// Attach IDs to every request in both headers & params so the backend can read either.
export function sessionRequestConfig() {
  const s = getSessionLocal();
  const headers = {
    "X-Tenant-Id": s.tenantId ?? "",
    "X-User-Id": s.userId ?? "",
    "X-Role-Id": s.roleId ?? "",
    "X-Role": s.role ?? "",
  };
  const params = {
    tenantId: s.tenantId ?? undefined,
    meId: s.userId ?? undefined,
    roleId: s.roleId ?? undefined,
    role: s.role ?? undefined,
  };
  return { headers, params, withCredentials: true };
}

// Simple edit gate: treat numeric roleId (2/3) or string 'editor'/'owner' as editors.
export function canEditFromSession() {
//   const { roleId, role } = getSessionLocal();
//   if (role === "owner" || role === "editor") return true;
//   if (roleId === 3 || roleId === 2) return true;  // adjust if your mapping differs
//   return false;
  const { roleId, role } = getSessionLocal();
  if (isEditRoleName(role)) return true;
  // Add any numeric role IDs here that should be editors
  const editRoleIds = new Set([1, 2, 3]); // e.g. 1=owner/admin, 2=manager, 3=editor
  return editRoleIds.has(Number(roleId));
}
